/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable indent */
import React from 'react';
import moment from 'moment';
import { saveAs } from 'file-saver';
import {
  ImportMinutageArchitectureAPI,
  GetMinutageArchitectureAPI,
  ExportChannelArchitectureMinutageAPI,
} from 'api';
import { formatDateWithMoment } from 'utils';
import Button from 'shared/components/button/Button';
import useStore from 'store/AccountStore';
import { OpSchedulerNext } from 'op2mise-react-widgets/OpSchedulerNext';
import { ImportComponent } from './modals/ImportComponent';
import ModifyGradingAndMinutage from './modals/ModifyGradingAndMinutage';
import SchedulerHeaderActions from './components/SchedulerHeaderActions';
import SchedulerDayHeader from './components/SchedulerDayHeader';
import { MinutageActionTypes } from './reducers/minutage.reducer';
import { getWeeklyEventDate } from './utils/eventAdapter';
import './ChannelArchitecture.css';

const renderMinutageEventContent = (eventInfo) => (
  <div className="ca-grading-event">
    <span>{Number(eventInfo.event.extendedProps.minutage).toFixed(2)}</span>
  </div>
);

const renderMinutageDayHeader = (args) => <SchedulerDayHeader {...args} />;

const renderMinutageHeaderActions = ({
  onUndo,
  canUndo,
  onImport,
  onExport,
}) => (
  <SchedulerHeaderActions
    onUndo={onUndo}
    canUndo={canUndo}
    onImport={onImport}
    onExport={onExport}
    showAdd={false}
  />
);

export function CAMinutage({
  canUndo,
  channelInfo,
  dispatchMinutage,
  handleConstructGridData,
  handleGetEventDate,
  handleSaveMinutageArchitecture,
  headerComponent,
  isDirty,
  minutage,
  setIsDirty,
  undoHistoryLength,
}) {
  const { user } = useStore((state) => state);
  const [openForm, setOpenForm] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const { channelId, channelName } = channelInfo;
  const [selectedSchedule, setSelectedSchedule] = React.useState({});
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const tomorrow = moment().add(1, 'days').toDate();

  const period = `${formatDateWithMoment(
    new Date().toDateString(),
  )} - ${formatDateWithMoment(tomorrow)}`;

  const schedulerEvents = React.useMemo(
    () => minutage.map((record) => ({
      id: record.id,
      title: Number(record.minutage).toFixed(2),
      start: getWeeklyEventDate(record.dayOfWeek, record.week, record.startTime),
      end: getWeeklyEventDate(record.dayOfWeek, record.week, record.endTime),
      extendedProps: record,
    })),
    [minutage],
  );

  const handleOnExport = () => {
    if (minutage.length) {
      ExportChannelArchitectureMinutageAPI({
        queryParams: { channelId },
        onSuccess: (res) => {
          const { organisationName } = user;
          const exportDate = new Date();
          const exportedDateString = String(exportDate.getDate()).padStart(2, '0')
            + String(exportDate.getMonth() + 1).padStart(2, '0')
            + exportDate.getFullYear().toString();
          const fileName = `${organisationName}_op2mise_channel_architecture_minutage_export_${channelName}_${exportedDateString}.xlsx`;
          const blob = new Blob([res], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          saveAs(blob, fileName);
        },
      });
    }
  };

  const handleOnSlotModified = (event) => {
    const record = event.extendedProps;
    setSelectedSchedule({
      ...record,
      startTime: handleGetEventDate(record, 'startTime'),
      endTime: handleGetEventDate(record, 'endTime'),
    });
    setIsDialogOpen(true);
  };

  const handleMinutageUpdate = (newMinutage) => {
    const record = minutage.find(({ id }) => id === selectedSchedule.id);
    if (!record) return;

    dispatchMinutage({
      actionType: MinutageActionTypes.UPDATE,
      payload: {
        record: { ...record, minutage: newMinutage },
      },
    });
    setIsDirty(true);
  };

  const handleUndo = () => {
    if (!canUndo) return;
    dispatchMinutage({ actionType: MinutageActionTypes.UNDO });
    setIsDirty(undoHistoryLength > 1);
  };

  const cleanOutInvalidMinutage = (data) => data.filter((schedule) => schedule.minutage);

  React.useEffect(() => {
    setIsDialogOpen(false);
  }, []);

  React.useEffect(() => {
    if (channelId) {
      GetMinutageArchitectureAPI({
        queryParams: { channelId },
        onSuccess: (response) => {
          const validMinutage = cleanOutInvalidMinutage(response);
          dispatchMinutage({
            actionType: MinutageActionTypes.LOAD,
            payload: {
              records: handleConstructGridData(validMinutage, true),
            },
          });
        },
        setLoader: setIsLoading,
      });
    }
  }, [channelId, dispatchMinutage, handleConstructGridData]);

  return (
    <>
      {' '}
      {openForm === 'IMPORT' && (
        <ImportComponent
          closeModal={() => setOpenForm('')}
          setIsDirty={setIsDirty}
          setIsLoading={setIsLoading}
          scheduleInfo={{
            ...channelInfo,
            period,
          }}
          schedulerData={{
            schedules: minutage,
            scheduleInfo: {
              ...channelInfo,
            },
            period,
          }}
          sampleTemplate="minutageImportTemplate"
          handleOnImportApi={ImportMinutageArchitectureAPI}
          dataExists="gradeMinutageArchitectureExist"
          dataModel="gradeMinutageArchitectureModel"
          fileError="gradeMinutageArchitectureError"
          importResultColumns={[
            {
              field: 'dayOfWeek',
              headerText: 'Day of Week',
            },
            {
              field: 'startTime',
              headerText: 'Start Time',
            },
            {
              field: 'endTime',
              headerText: 'End Time',
            },
            {
              field: 'minutage',
              headerText: 'Minutage',
            },
          ]}
          importResultFileTitle="minutage_import_result"
          setSchedules={(data) => {
            if (data.length) {
              const importedData = handleConstructGridData(data, true);
              dispatchMinutage({
                actionType: MinutageActionTypes.IMPORT,
                payload: { records: importedData },
              });
              setIsDirty(true);
              setIsLoading(false);
            }
          }}
        />
      )}

      {isDialogOpen && (
        <ModifyGradingAndMinutage
          isOpen={isDialogOpen}
          closeModal={() => setIsDialogOpen(false)}
          handleUpdate={handleMinutageUpdate}
          schedule={selectedSchedule}
          type="minutage"
        />
      )}

      {channelId === 0 && !channelName ? null : (
        <OpSchedulerNext
          contextMenu={{
            items: [
              {
                key: 'modify',
                label: 'Modify',
                iconCss: 'e-icons e-edit',
                onClick: (context) => handleOnSlotModified(context.event),
              },
            ],
          }}
          dayHeaderContent={renderMinutageDayHeader}
          eventContent={renderMinutageEventContent}
          eventDurationEditable={false}
          events={schedulerEvents}
          eventStartEditable={false}
          eventUpdateEnabled={false}
          header={{
            left: () => headerComponent,
            right: () => renderMinutageHeaderActions({
              onUndo: handleUndo,
              canUndo,
              onImport: () => setOpenForm('IMPORT'),
              onExport: handleOnExport,
            }),
          }}
          initialView="channelArchitectureView"
          isBroadcastClock={user?.clockType === 'Broadcast'}
          isLoading={isLoading}
          onEventDoubleClick={handleOnSlotModified}
          tooltip="off"
          views={{
            channelArchitectureView: {
              type: 'timeGridWeek',
              duration: { days: 7 },
              dateAlignment: 'week',
              firstDay: 1,
            },
          }}
        />
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
        <Button
          text="Save"
          onClick={() => handleSaveMinutageArchitecture(minutage)}
          disabled={!isDirty}
        />
      </div>
    </>
  );
}

export default CAMinutage;
